<template>
    <div v-if="pageLoader" class="loader-container">
        <RotatingLoader :size="30" :speed="0.6" />
        <p class="label">Loading your narrative ...</p>
    </div>
    <div class="narrative-stages-main-container" v-else>
        <DynamicPopup v-if="showDynamicPopup" v-model="showDynamicPopup"
            @generate-standard="handleGenerateNarrative(isOutputGenerated)" @generate-dynamic="onDynamicGenerate">
        </DynamicPopup>
        <div class="narrative-header">
            <div class="narrative-header-top" :class="{ 'flow-completed': isFlowCompleted }"
                v-if="!isCompleted || currentStage !== 5">
                <div class="header-wrapper" :class="{ 'flow-completed': isFlowCompleted }">
                    <button v-if="!isFlowCompleted" class="home-btn" @click="popupType = 'goHome'">
                        <img :src="require('@/assets/icons/home.svg')" alt="">
                    </button>
                    <div class="header-title-wrapper">
                        <div class="header-title">
                            <span class="doc-title">{{ docTitle }}</span>
                            <RenamePopup v-if="isEditingTitle" :docName="docTitle" :isEditing="isEditingTitle"
                                :id="$route.params.narrativeId" flowType="narrative"
                                @update-isEdit="isEditingTitle = $event" @updated-prTitle="docTitle = $event" />
                            <button class="edit-btn" @click="isEditingTitle = true">
                                <img :src="require('@/assets/icons/edit.svg')" />
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div v-if="isCompleted && currentStage === 5" class="narrative-header-top">
                <div class="final-head-wrapper">
                    <button class="back-btn" @click="goToHome()">
                        <img :src="require('@/assets/icons/back-arrow.svg')" alt="">
                    </button>
                    <span class="doc-title">Narrative Details</span>
                </div>
                <div class="final-pr-header-right">
                    <div>
                        <button v-if="false" class="share-btn" @click="showShareMenu = true">
                            <div class="completed-wrappershare">
                                <img :src="require('@/assets/icons/share.svg')"></img>
                            </div>
                        </button>
                        <!-- <v-dialog v-model="showShareMenu" :width="400" :close-on-content-click="false">
                            <div class="share-option-container">
                                <div class="options-header">
                                    <p>Share Options</p>
                                    <img :src="require('@/assets/icons/close.svg')"
                                        @click="showShareMenu = false"></img>
                                </div>
                                <a :href="'mailto' + shareUrl" class="share-option">
                                    <img :src="require('@/assets/icons/email.svg')"></img>
                                    <p>Send as Email</p>
                                </a>
                                <div class="share-option" @click="handleSlackShare">
                                    <img :src="require('@/assets/icons/slack.svg')" alt="Share on Slack">
                                    <p>Share on Slack</p>
                                </div>
                            </div>
                        </v-dialog> -->
                    </div>
                    <button class="generate-btn" :disabled="downloadLoader" @click="downloadNarrative">
                        <div class="continue-btn">
                            <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                            <p>Download</p>
                            <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                                :width="2"></v-progress-circular>
                        </div>
                    </button>
                </div>
            </div>
            <div class="header-stages" v-if="currentStage !== 5">
                <div :class="['stages-nav', { 'active-stage': currentStage === index + 1, 'completed-stage': currentStage > index + 1 }]"
                    v-for="(stage, index) in stages" :key="index">
                    <div class="stage">
                        <div class="num" v-if="currentStage <= index + 1">{{ index + 1 }}</div>
                        <div v-else class="check">
                            <img :src="require('@/assets/icons/tick-icon.svg')" />
                        </div>
                        <div>{{ stage }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="stage-content-container" :key="refresh">
            <Context v-if="narrative.lastUpdatedStage === 'Context'" v-model="context" @update:isFormValid="updateFormValid"
                @update:isEditingNarrative="updateEditingNarrative"
                @update:isRegeneratingQues="updateRegeneratingQues" />
            <Strategy v-if="narrative.lastUpdatedStage === 'Strategy'" v-model="strategy" @update:isFormValid="updateFormValid"
                @update:isEditingNarrative="updateEditingNarrative"
                @update:isRegeneratingQues="updateRegeneratingQues" />
            <Vision v-if="narrative.lastUpdatedStage === 'Vision'" v-model="vision" @update:isFormValid="updateFormValid"
                @update:autoGenerate="autoGenerate" @update:isEditingNarrative="updateEditingNarrative" />
            <FinalNarrativeDraft v-if="narrative.lastUpdatedStage === 'Final Draft'" v-model="finalNarrativeDraft" :generateAlternative="true"
                @update:isEditingNarrative="updateEditingNarrative" @complete-action="handleGenerateClick" :narrative-name="docTitle"/>
            <FinalNarrativeStage v-if="narrative.lastUpdatedStage === 'COMPLETED'" v-model="narrative" @update:modelValue="handleNarrativeUpdate" :isCompleted="isCompleted" @download-version="updateVersionType" @update-docTitle="docTitle = $event" :title="docTitle"/>
        </div>

        <div class="narrative-footer" v-if="currentStage !== 5">
            <div class="footer-left">
                <button class="delete-btn" @click="popupType = 'delete'"
                    :disabled="isEditingNarrative || isRegeneratingQues">
                    <img :src="require('@/assets/icons/delete.svg')" />
                    <v-progress-circular v-if="deleteLoader" indeterminate :size="18" :width="2"></v-progress-circular>
                </button>
                <button class="save-as-draft" @click="popupType = 'saveAsDraft'"
                    :disabled="isEditingNarrative || saveDraftLoader || isRegeneratingQues">
                    <img :src="require('@/assets/icons/save.svg')" />
                    <p>Save as Draft</p>
                </button>
            </div>
            <div class="footer-left" v-if="currentStage !== 4">
                <button class="generate-btn"
                    :disabled="!staticFormValid || isEditingNarrative || nextStageLoader || isRegeneratingQues"
                    @click="handleGenerateClick()">
                    <div v-if="!isOutputGenerated" class="generate-btn-img-wrapper">
                        <p v-if="currentStage === 3 && !isDynamicQnGenerated"> Generate {{ stages[currentStage - 1] }}
                            Themes</p>
                        <p v-else-if="currentStage <= 3"> Generate {{ stages[currentStage - 1] }}</p>
                        <p v-else>Finalize & Complete</p>
                        <img :src="require('@/assets/icons/next.svg')" alt="" />
                    </div>
                    <div class="continue-btn" v-else>
                        <p>{{ currentStage <= 3 || currentStage !==4 ? 'Continue' : 'Polish & Complete' }}</p>
                                <img :src="require('@/assets/icons/next.svg')" alt="" />
                    </div>
                    <v-progress-circular v-if="nextStageLoader" indeterminate :size="18"
                        :width="2"></v-progress-circular>
                </button>
            </div>
        </div>
        <v-overlay :model-value="isPolling" class="overlay" :persistent="isPolling">
            <RotatingLoader :size="30" :speed="0.6" />
            <span>{{ displayedMessage + ' ' + stages[currentStage - 1] }} ...</span>
        </v-overlay>
        <v-overlay v-if="smartGenerate" :model-value="smartGenerate" class="overlay" :persistent="smartGenerate">
            <RotatingLoader :size="30" :speed="0.6" />
            <span>{{ 'Generating' }}</span>
        </v-overlay>
    </div>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />
</template>

<script>
import RenamePopup from '@/components/RenamePopup.vue';
import DynamicPopup from '@/components/DynamicPopup.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import Strategy from './Strategy.vue';
import Context from './Context.vue';
import Vision from './Vision.vue';
import FinalNarrativeDraft from './FinalNarrativeDraft.vue';
import FinalNarrativeStage from './FinalNarrative.vue'
import RotatingLoader from '@/components/CircularProgressBar.vue'
import { downloadPr } from '@/helper/downloadPr';
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
export default {
    name: 'NarrativeDetails',
    components: {
        RenamePopup,
        DynamicPopup,
        CommonPopup,
        RotatingLoader,
        Context,
        Strategy,
        Vision,
        FinalNarrativeDraft,
        FinalNarrativeStage,
        RotatingLoader
    },
    data() {
        return {
            pageLoader: false,
            refresh: 0,
            docTitle: null,
            isEditingTitle: false,
            stages: ['Context', 'Strategy', 'Vision', 'Final Draft'],
            currentStage: 1,
            showDynamicPopup: false,
            smartGenerate: false,
            deleteLoader: false,
            nextStageLoader: false,
            pageLoader: false,
            showCommonPopup: false,
            popupType: null,
            narrative: {},
            context: {
                staticQues: {},
                dynamicQues: [],
                generatedContent: null
            },
            strategy: {
                staticQues: {},
                dynamicQues: [],
                generatedContent: null
            },
            vision: {
                staticQues: {},
                dynamicQues: [],
                generatedContent: null
            },
            finalNarrative: null,
            finalNarrativeDraft: {
                context: null,
                strategy: null,
                vision: null,
            },
            vision: {
                staticQues: {},
                dynamicQues: [],
                output: null
            },
            userInputQuestions: {
                context: {},
                strategy: {},
                vision: {}
            },
            isDynamicQnGenerated: false,
            staticFormValid: false,
            isOutputGenerated: false,
            isEditingNarrative: false,
            staticQuestions: {
                contextQuestions: {},
                strategyQuestions: {},
                visionQuestions: {}
            },
            saveDraftLoader: false,
            downloadLoader: false,
            isPolling: false,
            pollingStatus: null,
            displayedMessage: null,
            generatedNarrativeId: null,
            narrativeType: null,
            fineTuneLoader: false,
            generateNarrativeCounter: 0,
            narrativeId: null,
            isRegeneratingQues: false,
            isCompleted: false,
            isFlowCompleted: false,
            isAutoGenerate: false,
            originalNarrativeData: null,
            humanizedNarrativeData: null,
            shortenNarrativeData: null,
            versionType: null
        }
    },
    watch: {
        popupType() {
            if (this.popupType) {
                this.showCommonPopup = true;
            }
        },
    },
    methods: {
        updateVersionType(val) {
            this.versionType = val
        },
        async getNarrativeDetails(isFallback=false) {
            if(!isFallback) {
                this.pageLoader = true;
            }
            axiosInstance.get('/narrative/' + this.narrativeId)
                .then(async (response) => {
                    this.narrative = response.data.data;
                    this.docTitle = this.narrative.narrativeName;
                    if (this.narrative.lastUpdatedStage === 'COMPLETED') {
                        this.currentStage = 5;

                        this.finalNarrative = this.narrative.finalizedNarrative?.narrativeData;
                        this.isOutputGenerated = true;
                        this.isDynamicQnGenerated = true;
                        this.staticFormValid = true;
                        if (this.isFlowCompleted) {
                            this.isCompleted = false;
                        } else {
                            this.isCompleted = true;
                        }
                    } else if (this.narrative.lastUpdatedStage === 'Final Draft') {
                        this.currentStage = 4;
                        this.originalNarrativeData = this.narrative?.originalNarrativeData;
                        this.humanizedNarrativeData = this.narrative?.humanizedNarrativeData;
                        this.shortenNarrativeData = this.narrative?.shortenNarrativeData;
                        this.finalNarrativeDraft = {
                            originalNarrativeData: this.originalNarrativeData,
                            humanizedNarrativeData: this.humanizedNarrativeData,
                            shortenNarrativeData: this.shortenNarrativeData
                        }
                        this.isOutputGenerated = true;
                        this.isDynamicQnGenerated = true;
                        this.staticFormValid = true;
                    } else if (this.narrative.lastUpdatedStage === 'Vision') {
                        this.currentStage = 3;
                        if (this.narrative.generatedContent.vision) {
                            this.vision.generatedContent = this.narrative.generatedContent.vision;
                            this.isOutputGenerated = true;
                            this.isDynamicQnGenerated = true;
                            this.staticFormValid = true;
                        } else if (this.narrative.visionTheme?.length > 0) {
                            this.vision.visionThemes = this.narrative.visionTheme;
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = true;
                            this.staticFormValid = false;
                        }
                        else if (Object.keys(this.narrative.staticQuestions.vision || {}).length > 0) {
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = false;
                            this.vision.staticQues = this.narrative.staticQuestions.vision;
                        } else {
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = false;
                            if (Object.keys(this.staticQuestions.visionQuestions).length === 0) {
                                await this.getNarrativeQuestions();
                                this.vision.staticQues = this.staticQuestions.visionQuestions;
                            }
                            this.vision.staticQues = this.staticQuestions.visionQuestions.Vision;
                            this.isDynamicQnGenerated = false;
                            this.staticFormValid = false;
                        }
                    } else if (this.narrative.lastUpdatedStage === 'Strategy') {
                        this.currentStage = 2;
                        if (this.narrative.generatedContent.strategy) {
                            this.isOutputGenerated = true;
                            this.strategy.generatedContent = this.narrative.generatedContent.strategy;
                            this.isDynamicQnGenerated = true;
                            this.staticFormValid = true;
                            this.vision.staticQues = this.staticQuestions.visionQuestions.Vision;
                        } else if (this.narrative.dynamicQuestions.strategy.length > 0) {
                            this.isOutputGenerated = false;
                            this.strategy.dynamicQues = this.narrative.dynamicQuestions.strategy;
                            this.isDynamicQnGenerated = true;
                            this.staticFormValid = true;
                        } else if (Object.keys(this.narrative.staticQuestions.strategy || {}).length > 0) {
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = false;
                            this.strategy.staticQues = this.narrative.staticQuestions.strategy;
                        } else {
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = false;
                            if (Object.keys(this.staticQuestions.strategyQuestions).length === 0) {
                                await this.getNarrativeQuestions();
                                this.strategy.staticQues = this.staticQuestions.strategyQuestions;
                                this.vision.staticQues = this.narrative.staticQuestions.vision;
                            }
                            this.strategy.staticQues = this.staticQuestions.strategyQuestions.Strategy;
                            this.isDynamicQnGenerated = false;
                            this.staticFormValid = false;
                        }
                    } else {
                        this.currentStage = 1;
                        if (this.narrative.generatedContent.context) {
                            this.isOutputGenerated = true;
                            this.context.generatedContent = this.narrative.generatedContent.context;
                            this.isDynamicQnGenerated = true;
                            this.staticFormValid = true;
                            this.context.staticQues = this.narrative.staticQuestions.context
                            this.strategy.staticQues = this.staticQuestions.strategyQuestions.Strategy;

                        } else if (this.narrative.dynamicQuestions.context.length > 0) {
                            this.isOutputGenerated = false;
                            this.context.dynamicQues = this.narrative.dynamicQuestions.context;
                            this.isDynamicQnGenerated = true;
                            this.staticFormValid = true;
                        } else if (Object.keys(this.narrative.staticQuestions.context || {}).length > 0) {
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = false;
                            this.context.staticQues = this.narrative.staticQuestions.context;
                        } else {
                            this.isOutputGenerated = false;
                            this.isDynamicQnGenerated = false;
                            if (Object.keys(this.staticQuestions.contextQuestions).length === 0) {
                                await this.getNarrativeQuestions();
                                this.context.staticQues = this.staticQuestions.contextQuestions;
                            }
                            this.context.staticQues = this.staticQuestions.contextQuestions.Context;
                            this.isDynamicQnGenerated = false;
                            this.staticFormValid = false;
                        }
                    }
                    this.refresh += 1;
                })
                .catch((error) => {
                    console.error("[ERROR] ", error);
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Error fetching narrative details',
                    });
                })
                .finally(() => {
                    this.pageLoader = false;
                });
        },
        async getNarrativeQuestions() {
            let narrativeTypeId;
            await axiosInstance.get('/narrative/type')
                .then((response) => {
                    this.narrativeTypes = response.data.data;
                    narrativeTypeId = response.data.data[0].id;
                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Error fetching narrative types',
                    });
                })
            if (!narrativeTypeId) return;
            await axiosInstance.get('/narrative/question', { params: { typeId: narrativeTypeId } })
                .then((response) => {
                    for (const [stage, qns] of Object.entries(response.data.data)) {
                        if (stage === 'strategyQuestions') {
                            this.staticQuestions[stage] = qns.reduce((acc, item) => {
                                (acc[item.questionCategory] = acc[item.questionCategory] || []).push(item);
                                return acc;
                            }, {}) || {};
                        } else {
                            this.staticQuestions[stage] = qns.reduce((acc, item) => {
                                (acc[item.questionCategory] = acc[item.questionCategory] || []).push(item);
                                return acc;
                            }, {}) || {};
                        }

                    }
                })
        },
        updateFormValid(val) {
            this.staticFormValid = val;
        },
        autoGenerate(val) {
            this.isAutoGenerate = val;
        },
        updateRegeneratingQues(val) {
            this.isRegeneratingQues = val;
        },
        updateEditingNarrative(val) {
            this.isEditingNarrative = val;
        },
        async handleNarrativeUpdate(val){
            await this.getNarrativeDetails();
        },
        async generateDynamicQn() {
            this.fineTuneLoader = true;
            await this.saveAsDraft('dynamicQn');
            let payload = {
                narrativeId: this.$route.params.narrativeId
            }
            axiosInstance.post('/narrative/dynamicQuestions', payload)
                .then(async (response) => {
                    if (this.currentStage === 1) {
                        this.context.dynamicQues = response.data.data.questions;
                    } else if (this.currentStage === 2) {
                        this.strategy.dynamicQues = response.data.data.questions;
                    }
                    this.isDynamicQnGenerated = true;
                    await this.getNarrativeDetails();
                    this.smartGenerate = false;

                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to generate dynamic questions',
                    });
                })
                .finally(() => {
                    this.smartGenerate = false;
                    this.refresh += 1;
                })
        },

        async saveAsDraft(btnType) {
            let payload = {
                narrativeId: this.narrativeId,
            };
            if (this.currentStage === 1) {
                payload.lastUpdatedStage = btnType === 'continue' ? 'Strategy' : 'Context';
                if (this.isOutputGenerated) {
                    payload.context = {
                        contextContent: this.context.generatedContent
                    };
                } else if (this.isDynamicQnGenerated) {
                    payload.dynamicContentWithQuestion = { contextDynamicQuestions: this.context.dynamicQues };
                } else {
                    let contextStaticQnArray = [];
                    for (const [key, value] of Object.entries(this.context.staticQues)) {
                        contextStaticQnArray.push(value);
                    }

                    payload.responseObjectWithQuestion = { context: contextStaticQnArray };
                }
            } else if (this.currentStage === 2) {
                payload.lastUpdatedStage = btnType === 'continue' ? 'Vision' : 'Strategy';

                if (this.isOutputGenerated) {
                    payload.strategy = {
                        strategyContent: this.strategy.generatedContent
                    };
                    payload.context = {
                        contextContent: this.narrative.generatedContent.context
                    };
                } else if (this.isDynamicQnGenerated) {
                    payload.dynamicContentWithQuestion = { contextDynamicQuestions: this.context.dynamicQues };
                    payload.dynamicContentWithQuestion = { strategyDynamicQuestions: this.strategy.dynamicQues };
                } else {
                    let strategyStaticQnArray = [];
                    for (const [key, value] of Object.entries(this.strategy.staticQues)) {
                        strategyStaticQnArray.push(value);
                    }
                    payload.responseObjectWithQuestion = {
                        strategy: strategyStaticQnArray
                    };
                }
            } else if (this.currentStage === 3) {
                payload.lastUpdatedStage = btnType === 'continue' ? 'Final Draft' : 'Vision';
                if (this.isOutputGenerated) {
                    payload.vision = {
                        visionContent: this.vision.generatedContent
                    };
                    payload.strategy = {
                        strategyContent: this.narrative.generatedContent.strategy
                    };
                    payload.context = {
                        contextContent: this.narrative.generatedContent.context
                    };
                    if (btnType === 'continue') {
                        payload.originalNarrativeData = this.narrative.generatedContent.context + this.narrative.generatedContent.strategy + this.vision.generatedContent;
                    }
                } else if (this.isDynamicQnGenerated) {
                    payload.visionTheme = this.vision.visionThemes;
                    payload.dynamicContentWithQuestion = { strategyDynamicQuestions: this.strategy.dynamicQues };
                } else {
                    let visionStaticQnArray = [];
                    for (const [key, value] of Object.entries(this.vision.staticQues)) {
                        visionStaticQnArray.push(value);
                    }
                    payload.responseObjectWithQuestion = {
                        vision: visionStaticQnArray
                    };
                    payload.isAutoGenerated = this.isAutoGenerate;
                }
            }
            else if (this.currentStage === 4) {
                if (btnType === 'continue') {
                    payload.lastUpdatedStage = 'COMPLETED';
                } else {
                    payload.lastUpdatedStage = 'Final Draft'
                    payload.originalNarrativeData = this.finalNarrativeDraft?.originalNarrativeData;
                    payload.humanizedNarrativeData = this.finalNarrativeDraft?.humanizedNarrativeData;
                    payload.shortenNarrativeData = this.finalNarrativeDraft?.shortenNarrativeData;
                }

            }
            await axiosInstance.put('/narrative/saveDraft', payload)
                .then((response) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'save',
                        message: 'Changes saved successfully',
                        redirect: btnType === 'draft' ? { name: 'NarrativeHome' } : ''
                    });
                })
                .catch((error) => {
                    console.error('[ERROR] ', error);
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
        },
        async handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    axiosInstance.put('/narrative/delete', { narrativeId: this.$route.params.narrativeId })
                        .then((response) => {
                            this.goToHome()
                        })
                        .catch((error) => {
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Error deleting narrative',
                            });
                        })
                }
                else if (this.popupType === 'saveAsDraft') {
                    this.saveDraftLoader = true;
                    await this.saveAsDraft('draft');
                    this.saveDraftLoader = false;
                }
                else {
                    this.$router.push({ name: 'NarrativeHome' });
                }
            }
            this.popupType = null;
        },

        async onDynamicGenerate() {
            this.showDynamicPopup = false;
            this.smartGenerate = true;
            await this.generateDynamicQn();

        },

        handleGenerateClick(versionType) {
            if (!this.isDynamicQnGenerated && this.currentStage === 1) {
                this.showDynamicPopup = true;
            }
            else if (!this.isDynamicQnGenerated && this.currentStage === 3) {
                this.generateVisionTheme();
            }
            else {
                this.handleGenerateNarrative(this.isOutputGenerated, versionType)
            }
        },

        async generateVisionTheme() {
            this.smartGenerate = true;
            await this.saveAsDraft('dynamicQn');
            let payload = {
                narrativeId: this.$route.params.narrativeId,
                isAutoGenerated: this.isAutoGenerate
            }
            if (!this.isAutoGenerate) {
                payload.inputBrief = this.vision.staticQues[0].answer;
            }

            axiosInstance.post('/narrative/vision/statements', payload)
                .then((response) => {
                    this.getNarrativeDetails();
                    this.isDynamicQnGenerated = true;
                    this.smartGenerate = false;
                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to generate dynamic questions',
                    });
                })
                .finally(() => {
                    this.smartGenerate = false;
                    this.refresh += 1;
                })
        },

        async completeNarrative(versionType) {
            let payload = {
                narrativeId: this.$route.params.narrativeId,
                finalizedVersion: versionType
            }
            axiosInstance.put('/narrative/complete', payload)
                .then(async (response) => {
                    this.isFlowCompleted = true;
                    await this.getNarrativeDetails();

                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to update narrative status',
                    });
                })
        },

        async handleGenerateNarrative(continueBtnClicked, versionType) {
            this.nextStageLoader = true;
            if (continueBtnClicked) {
                await this.saveAsDraft('continue');
                this.currentStage += 1;
                if (this.currentStage === 4) {
                    await this.humanizeNarrative();
                }

                if (this.currentStage < 5) {
                    await this.getNarrativeDetails();
                } else {
                    await this.completeNarrative(versionType);
                }
            } else if (this.currentStage <= 3) {
                this.isPolling = true;
                this.displayedMessage = "Generating"
                let payload = {
                    narrativeId: this.narrativeId
                }

                if (this.currentStage === 1) {
                    await this.saveAsDraft('generateContent');
                    await axiosInstance.post('/narrative/context', payload)
                        .then(async (response) => {
                            if (response.status === 200) {
                                this.displayedMessage = "Completed"
                                this.nextStageLoader = false
                                // this.currentStage += 1;
                                this.isDynamicQnGenerated = true;
                                this.isOutputGenerated = true;
                                this.showDynamicPopup = false;
                                await this.getNarrativeDetails();
                                this.isPolling = false;
                            }
                        })
                        .catch((error) => {
                            if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                                this.isPolling = true;
                                let attempts = 0;
                                let maxAttempts = 40;
                                const intervalTime = 15000;
                                const intervalId = setInterval(async () => {
                                    attempts++;
                                    try {
                                        let isFallback = true;
                                        await this.getNarrativeDetails(isFallback);
                                        if (this.narrative.generatedContent.context && this.narrative.generatedContent.context.trim() !== "") {
                                            clearInterval(intervalId);
                                            this.displayedMessage = "Completed"
                                            this.nextStageLoader = false
                                            // this.currentStage += 1;
                                            this.isDynamicQnGenerated = true;
                                            this.isOutputGenerated = true;
                                            this.showDynamicPopup = false;
                                            this.isPolling = false;
                                            
                                        } else if (attempts >= maxAttempts) {
                                            clearInterval(intervalId);
                                             this.isPolling = false;
                                        }

                                    } catch (pollError) {
                                        console.error("Error during polling:", pollError);
                                        clearInterval(intervalId);
                                         this.isPolling = false;
                                        Eventbus.emit('commonSnackbar', {
                                            snackType: 'error',
                                            message: 'Failed to generate Narrative. Please try again later.'
                                        });
                                    }
                                }, intervalTime);
                            }

                        })

                } else if (this.currentStage === 2) {
                    await this.saveAsDraft('generateContent');
                    await axiosInstance.post('/narrative/strategy', payload)
                        .then(async (response) => {
                            if (response.status === 200) {
                                this.displayedMessage = "Completed"
                                this.nextStageLoader = false
                                // this.currentStage += 1;
                                this.isDynamicQnGenerated = true;
                                this.isOutputGenerated = true;
                                await this.getNarrativeDetails();
                                this.isPolling = false;
                            }
                        })
                        .catch((error) => {
                              if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                                 this.isPolling = true; 
                                let attempts = 0;
                                let maxAttempts = 40;
                                const intervalTime = 15000;
                                const intervalId = setInterval(async () => {
                                    attempts++;
                                    try {
                                        await this.getNarrativeDetails();
                                        if (this.narrative.generatedContent.strategy && this.narrative.generatedContent.strategy.trim() !== "") {
                                            clearInterval(intervalId);
                                            this.displayedMessage = "Completed"
                                            this.nextStageLoader = false
                                             this.isPolling = false;
                                            // this.currentStage += 1;
                                            this.isDynamicQnGenerated = true;
                                            this.isOutputGenerated = true;
                                            this.showDynamicPopup = false;
                                        } else if (attempts >= maxAttempts) {
                                            clearInterval(intervalId);
                                             this.isPolling = false;
                                        }

                                    } catch (pollError) {
                                        console.error("Error during polling:", pollError);
                                        clearInterval(intervalId);
                                         this.isPolling = false;
                                        Eventbus.emit('commonSnackbar', {
                                            snackType: 'error',
                                            message: 'Failed to generate Narrative. Please try again later.'
                                        });
                                    }
                                }, intervalTime);
                            }
                        })
                        
                } else if (this.currentStage === 3) {
                    await this.saveAsDraft('generateContent');
                    let selectedTheme = this.vision.visionThemes.find(t => t.isSelected) || {};
                    payload.selectedTheme = `<h1>VISION</h1><p>${selectedTheme.statement}</p>`;
                    await axiosInstance.post('/narrative/vision', payload)
                        .then(async (response) => {
                            if (response.status === 200) {
                                this.displayedMessage = "Completed"
                                this.nextStageLoader = false
                                // this.currentStage += 1;
                                this.isDynamicQnGenerated = true;
                                this.isOutputGenerated = true;
                                await this.getNarrativeDetails();
                                this.isPolling = false;
                            }
                        })
                        .catch((error) => {
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to update narrative status',
                            });
                        }).finally(() => {
                            this.isPolling = false;
                        })
                } else if (this.currentStage === 4) {
                    this.smartGenerate = false;
                    this.isPolling = false;
                    await this.saveAsDraft('continue');
                    this.currentStage += 1;
                    this.finalNarrative = this.finalNarrativeDraft.context + '<br>' + this.finalNarrativeDraft.strategy + '<br>' + this.finalNarrativeDraft.vision;
                }
            }
            this.nextStageLoader = false;
            this.refresh += 1;
        },
        goToHome() {
            this.$router.push({ name: 'NarrativeHome' });
        },
        async downloadNarrative() {
            this.downloadLoader = true;
            let payload = {
                narrativeId: this.narrativeId,
                flowType: 'NARRATIVE',
                versionType: this.versionType
            }

            if (this.versionType && this.versionType.startsWith('version-')) {
                const versionNum = parseInt(this.versionType.split('-')[1]);
                if (!isNaN(versionNum)) {
                    payload.version = versionNum;
                }
            }
            let filename = `${this.docTitle}_${payload.versionType}`;

            await downloadPr(payload, filename);
            axiosInstance.post('/document/download', payload)
            this.downloadLoader = false;

        },
        async humanizeNarrative() {
            this.smartGenerate = true;
            let payload = {
                narrativeId: this.narrativeId
            };

            let endpoint = '/narrative/humanize';

            try {
                await axiosInstance.post(endpoint, payload)
                if (response.status === 200) {
                    this.smartGenerate = false;
                }

            } catch (error) {
                if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            await this.getNarrativeDetails();
                            if (this.humanizedNarrativeData && this.humanizedNarrativeData.trim() !== "") {
                                this.smartGenerate = false;
                                clearInterval(intervalId);
                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                this.smartGenerate = false;
                            }
                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                             this.isPolling = false;
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate Narrative. Please try again later.'
                            });
                        }
                    }, intervalTime);
                }
            } finally {
                this.smartGenerate = false;
            }

        }
    },
    async mounted() {
        this.narrativeId = this.$route.params.narrativeId
        await this.getNarrativeDetails();
    },
}
</script>

<style scoped>
.header-wrapper {
    width: 54%;
    display: flex;
    justify-content: space-between;
    gap: 4.5rem;
    max-height: 44px;
}

.final-head-wrapper {
    width: 54%;
    display: flex;
    gap: 12px;
    align-items: center;
    max-height: 44px;
}

.final-narrative-control-buttons {
    display: flex;
    flex-direction: row;
    gap: 0.5rem
}

.final-narrative-control-buttons button {
    padding: 10px 24px;
}

.narrative-stages-main-container {
    display: flex;
    background: var(--dark-background);
    background-size: 100% 100%;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

.narrative-header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF09;
    color: white;
    z-index: 100;
}

.narrative-header-top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom-width: 1px;
    padding: 0.5em 2em;
}

.flow-completed {
    width: fit-content;
    justify-content: center;
}

.home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF1F;
    border-radius: 8px;
    padding: 10px;

}

.back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFFFF;
    border-radius: 50px;
    padding: 10px;

}

.header-title-wrapper {
    display: flex;
    justify-content: space-between;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.doc-title {
    font-weight: 500;
    text-align: center;
}

.final-pr-header-right {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 12px;
}

.download_btn {
    margin-left: 20px;
}

.edit-btn {
    display: flex;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
}

.control-btn {
    display: flex;
    padding: 10px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
}

.download {
    background: #FF00C3;
}

.header-stages {
    width: 100%;
    display: flex;
}

.stages-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: #ffffff08;
    border-width: 1px 1px 1px 0px;
    border-style: solid;
    border-color: #FFFFFF33;
}

.active-stage {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800), rgba(0, 0, 0, 0.6);
    background-blend-mode: multiply;
    border-color: #FF00C340;
}

.completed-stage {
    background: #5F003F;
    border-color: #FF00C340;
}

.stage {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.5em;
}

.num {
    background: #FFFFFF33;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    padding: 10px;
    border-radius: 50%;
    color: #D4D4D4;
}

.active-stage .num {
    color: white;
    background-color: #FF00C3;
}

.check {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    padding: 10px;
    border-radius: 50%;
    background-color: #FF00C3;
    color: white;
}

.stage-content-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    will-change: transform;
    scrollbar-width: thin;
}

.narrative-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5em 2em;
    background: #180914;
    border-top: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.footer-left {
    display: flex;
    gap: 1em;
    align-items: center;
}

.delete-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.share-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.completed-wrappershare {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.save-as-draft {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 8px 24px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.fine-tune-wrapper {
    display: flex;
    align-items: center;
    gap: 2em;
    position: relative;
    background: linear-gradient(86.34deg, rgba(255, 0, 195, 0.4) 7.5%, rgba(255, 10, 25, 0.4) 50.5%, rgba(255, 120, 0, 0.4) 96%);
    border-radius: 8px;
    padding: 8px 16px;
    border: 1.5px solid transparent;
}

.fine-tune-wrapper::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(86.34deg, rgba(255, 0, 195, 0.4) 7.5%, rgba(255, 10, 25, 0.4) 50.5%, rgba(255, 120, 0, 0.4) 96%);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
}


.fine-tune-left {
    display: flex;
    align-items: center;
    gap: 0.8em;
}

.ai-img {
    width: 30px;
    height: 30px;
}

.ai-name-wrapper {
    display: flex;
    flex-direction: column;
}

.label {
    color: #D4D4D4;
    font-size: 14px;
}

.name-end-wrapper {
    font-size: 16px;
}

.super-text {
    font-size: 14px;
}

.i-btn {
    display: flex;
    align-items: center;
    background: #FFFFFF14;
    border: 1px solid #FFFFFF33;
    border-radius: 6px;
    padding: 0.5em;
}

.fine-tune-btn {
    display: flex;
    align-items: center;
    border-radius: 6px;
    gap: 8px;
    padding: 6px 8px;
    position: relative;
    background: linear-gradient(86.34deg, rgba(255, 0, 195, 0.5) 7.5%, rgba(255, 10, 25, 0.5) 50.5%, rgba(255, 120, 0, 0.5) 96%);
    border: 1px solid transparent;
}

.fine-tune-btn::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 0.5px;
    border-radius: 6px;
    background: linear-gradient(86.34deg, #FF00C3 7.5%, #FF0A19 50.5%, #FF7800 96%);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
}

.fine-tune-btn :disabled {
    cursor: not-allowed;
    opacity: 0.9;
}

.diamond-wrapper {
    display: flex;
    gap: 4px;
    align-items: center;
}

.generate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    background: var(--primary-gradient-with-black)
}

.generate-btn-img-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    /* background: #FF00C3; */
}

.generater-btn:disabled {
    opacity: 0.9;
    cursor: not-allowed;
}

.continue-btn {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.overlay :deep(.v-overlay__content) {
    display: flex;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 1rem;
}
</style>